import styled from "styled-components";

export const CommunitiesContainer = styled.div`
  height: calc(100% - 32px);

  @media (min-width: 990px) {
    margin-top: 4rem;
  }

  .spotlights {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
  }

  .spotlights {
    cursor: pointer;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;
    background: ${({ theme }) => theme?.colors?.headerBackgroundColor};

    .community-info {
      font-family: Roboto;
      font-style: normal;
      font-weight: 900;
      font-size: 13px;
      line-height: 15px;

      display: flex;
      justify-content: center;
      align-items: center;

      width: 130px;
      height: 21px;
      border-radius: 4px;
      margin: 0 0 5px 0;

      background-color: ${({ theme }) => theme?.colors?.btnTextColor};
      color: ${({ theme }) => theme?.colors?.primary};
    }

    h1.title,
    p.description {
      text-align: center;

      color: ${({ theme }) => theme?.colors?.headerTextColor};
    }

    h1.title {
      font-family: Poppins;
      font-style: normal;
      font-weight: bold;
      font-size: 40px;
      line-height: 122%;
      letter-spacing: -0.5px;
    }

    p.description {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 100%;
      margin-bottom: 0;
      max-width: 80vw;
    }
  }
`;

export const Forum = styled.div`
  display: flex;
  justify-content: center;
`;
